'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addImplicitReturns = addImplicitReturns;
exports.toPlainFunction = toPlainFunction;
exports.replaceWithPlainFunction = replaceWithPlainFunction;
exports.toArrowFunction = toArrowFunction;
exports.replaceWithArrowFunction = replaceWithArrowFunction;
exports.toBlockArrowFunctionExpression = toBlockArrowFunctionExpression;
exports.ensureBlockArrowFunctionExpression = ensureBlockArrowFunctionExpression;
exports.replaceWithBoundFunction = replaceWithBoundFunction;
exports.isNamedArrowFunction = isNamedArrowFunction;

var _is = require('./is');

var _is2 = _interopRequireDefault(_is);

var _tails = require('./tails');

var _types = require('./types');

var _types2 = _interopRequireDefault(_types);

var _blocks = require('./blocks');

var _getLoc = require('ast-loc-utils/lib/getLoc');

var _getLoc2 = _interopRequireDefault(_getLoc);

var _placeAtNode = require('ast-loc-utils/lib/placeAtNode');

var _placeAtNode2 = _interopRequireDefault(_placeAtNode);

var _placeAtLoc = require('ast-loc-utils/lib/placeAtLoc');

var _placeAtLoc2 = _interopRequireDefault(_placeAtLoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Add "return" statements to all expressions in tail position inside the
// body of the function at the given Babel traversal path.
function addImplicitReturns(functionPath) {
  var _ref;

  var node = functionPath.node;
  // Don't add implicit returns to constructors, setters, or :void functions
  if (node.kind === "constructor" || node.kind === "set") return;
  if ((0, _is2.default)("VoidTypeAnnotation", (_ref = node.returnType) == null ? null : _ref.typeAnnotation)) return;

  // Implicit return transformations
  function transform(expr, path) {
    if ((0, _is.isa)(path, "VariableDeclaration")) {
      if (path.node.declarations.length > 1) {
        throw path.buildCodeFrameError("Ambiguous implicit `return` of multiple variables. " + "Add an explicit `return` statement on the next line.");
      }
    }if ((0, _is.isa)(expr, "AwaitExpression")) {
      return (0, _placeAtNode2.default)(_types2.default.returnStatement(expr.argument), expr);
    } else {
      return (0, _placeAtNode2.default)(_types2.default.returnStatement(expr), expr);
    }
  }return (0, _tails.transformTails)(functionPath.get("body"), false, false, transform);
} // Convert any functional node (NamedArrow etc) back to a JS
// `FunctionDeclaration` or `FunctionExpression`
function toPlainFunction(node) {
  var id = node.id,
      params = node.params,
      body = node.body,
      generator = node.generator,
      async = node.async;


  var nextNode = function (_it) {
    if ((0, _is.isa)(_it, "Statement")) {
      return (0, _placeAtNode2.default)(_types2.default.functionDeclaration(id, params, (0, _blocks.toBlockStatement)(body), generator, async), node);
    } else {
      return (0, _placeAtNode2.default)(_types2.default.functionExpression(id, params, (0, _blocks.toBlockStatement)(body), generator, async), node);
    }
  }(node);if (node.returnType) nextNode.returnType = node.returnType;
  if (node.typeParameters) nextNode.typeParameters = node.typeParameters;

  return nextNode;
}function replaceWithPlainFunction(path) {
  return path.replaceWith(toPlainFunction(path.node));
} // Convert any functional node (NamedArrow etc) back to a JS arrow function
// `ArrowFunctionExpression`
function toArrowFunction(node) {
  var id = node.id,
      params = node.params,
      body = node.body,
      async = node.async;

  var fn = (0, _placeAtNode2.default)(_types2.default.arrowFunctionExpression(params, body, async), node);
  if (node.returnType) fn.returnType = node.returnType;
  if (node.typeParameters) fn.typeParameters = node.typeParameters;

  if ((0, _is.isa)(node, "Statement")) {
    return (0, _placeAtNode2.default)(_types2.default.variableDeclaration("const", [(0, _placeAtNode2.default)(_types2.default.variableDeclarator(id, fn), node)]), node);
  } else {
    return fn;
  }
}function replaceWithArrowFunction(path) {
  return path.replaceWith(toArrowFunction(path.node));
}function toBlockArrowFunctionExpression(node) {
  var params = node.params,
      body = node.body,
      async = node.async,
      skinny = node.skinny;

  var fn = (0, _placeAtNode2.default)(_types2.default.arrowFunctionExpression(params, (0, _blocks.toBlockStatement)(body), async), node);
  if (skinny) fn.skinny = true;
  if (node.returnType) fn.returnType = node.returnType;
  if (node.typeParameters) fn.typeParameters = node.typeParameters;

  return fn;
}function ensureBlockArrowFunctionExpression(path) {
  if ((0, _is.isa)(path.node, "ArrowFunctionExpression")) {
    return path.replaceWith(toBlockArrowFunctionExpression(path.node));
  }
} // Replace a functional node with a new node binding the function to `this`.
function replaceWithBoundFunction(path) {
  var node = path.node;

  var loc = (0, _getLoc2.default)(node);
  if ((0, _is.isa)(path.node, "Statement")) {
    // function f() {...}
    // f = f.bind(this)
    replaceWithPlainFunction(path);

    var assignToBound = (0, _placeAtLoc2.default)(_types2.default.assignmentExpression("=", path.node.id, (0, _placeAtLoc2.default)(_types2.default.callExpression((0, _placeAtLoc2.default)(_types2.default.memberExpression(path.node.id, (0, _placeAtLoc2.default)(_types2.default.identifier("bind"), loc)), loc), [(0, _placeAtLoc2.default)(_types2.default.thisExpression(), loc)]), loc)), loc);

    return path.insertAfter(assignToBound);
  } else {
    // (function f() {...}).bind(this)
    var bound = (0, _placeAtLoc2.default)(_types2.default.callExpression((0, _placeAtLoc2.default)(_types2.default.memberExpression(toPlainFunction(path.node), (0, _placeAtLoc2.default)(_types2.default.identifier("bind"), loc)), loc), [(0, _placeAtLoc2.default)(_types2.default.thisExpression(), loc)]), loc);

    return path.replaceWith(bound);
  }
}function isNamedArrowFunction(node) {
  // XXX: this seems a bit hackish.
  return typeof node.skinny === "boolean";
}